var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"reading-mark",attrs:{"label":"Прочитал(а)","disabled":""},model:{value:(_vm.value.mark_reading),callback:function ($$v) {_vm.$set(_vm.value, "mark_reading", $$v)},expression:"value.mark_reading"}})}
var staticRenderFns = []

export { render, staticRenderFns }